<template>
  <div class="ad-show-style-block">
    <div class="msg-title">
      <h1>广告展现形式</h1>
      <hr>
    </div>
    <div class="msg-content">
      <div class="wrapper">
        <div class="line-1">
          <div class="social-ad">
            <h1>1. 社交广告</h1>
            <p>马拉松照片将企业广告合二为一，参选手将主动来<br>
              跑团邦平台下载照片，在微信、微博、贴吧等社交平台传播分享<br>
              分享，形成裂变广告。</p>
          </div>
          <div class="self-media">
            <h1>2. 自媒体传播</h1>
            <p>自媒体包括<br>
              微信公众号、搜狐号、百家号、头条号等平台<br>
              宣传马拉松照片软文<br>
              帮助企业拓展更多渠道品牌曝光</p>
          </div>
        </div>
        <div class="line-2">
          <div class="location-ad">
            <h1>3. 马拉松场地广告</h1>
            <p>依托马拉松赛事影响力<br>
              在马拉松赛事现场摆放企业广告位<br>
              提升品牌曝光，覆盖马拉松现场人群</p>
          </div>
          <div class="race-marketing">
            <h1>4. 体育赛事营销策划</h1>
            <p>定制体育赛事策划<br>
              为品牌增值,给企业引流<br>
              创造各大的商业价值体系</p>
          </div>
          <div class="hot-person">
            <h1>5. 体育网红代言</h1>
            <p>体育网红是每场赛事的亮点之一,关注度极高<br>
              通过体育网红对品牌的代言,彰显企业实力<br>
              提升品牌知名度</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdShowStyles'
}
</script>

<style scoped lang="stylus">
  .ad-show-style-block
    width: 1100px
    margin: 0 auto
    .msg-title
      margin-top: 100px
      h1
        font-size: 35px
        font-weight: 500
        margin-bottom: 10px
      hr
        margin-top: 0
        width: 221px
        border: 4.5px solid #d6010f
        display:inline-block
    .msg-content
      padding-bottom: 187px
      .wrapper
        /*display: grid*/
        /*grid-template-columns: 174px 174px 174px 174px 174px 174px*/
        /*grid-template-rows: 347px 467px*/
        /*grid-template-areas: "sa sa sa sm sm sm" "la la rm rm hp hp"*/
        /*grid-row-gap: 19px*/
        margin-top: 80px
        color: white
        h1
          font-size: 33px
          font-weight: 300
        p
          font-size: 13px
          line-height: 25px
          width: 100%
          text-align: center
          margin: 0 0 15px 0

        .line-1
          display: flex
          height: 347px
          .social-ad
            background-image: url("../../../assets/images/style-social-ad-bg.png")
            background-position: center
            background-size: cover
            width: 50%
            h1
              margin: 123px 0 29px 101px
            p
              line-height: 25px
              width: 390px
              text-align: center
          .self-media
            width: 50%
            background-image: url("../../../assets/images/style-self-media-bg.png")
            background-position: center
            background-size: cover
            h1
              margin: 123px 0 0 86px
            p
              line-height: 25px
              width: 390px
              text-align: center
        .line-2
          display: flex
          height: 467px
          justify-content: space-between
          margin-top: 20px

          .location-ad
            background-image: url("../../../assets/images/style-location-ad-bg.png")
            background-position: center
            background-size: cover
            width: 348px
            h1
              margin: 340px 0 10px 29px
          .race-marketing
            width: 348px
            margin-left: 19px
            background-image: url("../../../assets/images/style-marketing-bg.png")
            background-position: center
            background-size: cover
            h1
              margin: 340px 0 10px 11px
          .hot-person
            width: 348px
            margin-left: 19px
            background-image: url("../../../assets/images/style-hot-person-bg.png")
            background-position: center
            background-size: cover
            h1
              margin: 340px 0 10px 51px
</style>



// WEBPACK FOOTER //
// src/pages/adStyle/components/AdShowStyles.vue